<template>
  <!--
    A ROLETA (redesign 03/09). A versão antiga desenhava peixes de SVG inline, ondas, feixes de
    luz e sparkles — tudo em CSS, tudo piscando (contra o D0 e contra a regra da arte). Agora a
    roda gira sobre o abismo do jogo, e as três explicações são notas pregadas (papel-quadro).
    A roda em si vive em shared/components/Roulette.vue — aqui é só o lugar dela.
  -->
  <FishScene cena="abissal" :escurecimento="0.5" class="fortuna">
    <div class="fortuna__interior">
      <div class="fortuna__topo">
        <h1 class="fortuna__titulo banner-titulo">{{ $t('roulette.roulette.title') }}</h1>
        <p class="fortuna__conversa">{{ $t('roulette.roulette.subtitle') }}</p>
      </div>

      <div class="fortuna__roda">
        <Roulette :playerId="playerId" ref="roulette" />
      </div>

      <ul class="fortuna__notas">
        <li class="papel-quadro fortuna__nota">
          <FishIcon nome="ticket-alt" tamanho="grande" />
          <h3>{{ $t('roulette.roulette.howToGet.title') }}</h3>
          <p>{{ $t('roulette.roulette.howToGet.description') }}</p>
        </li>
        <li class="papel-quadro fortuna__nota">
          <FishIcon nome="gift" tamanho="grande" />
          <h3>{{ $t('roulette.roulette.rewards.title') }}</h3>
          <p>{{ $t('roulette.roulette.rewards.description') }}</p>
        </li>
        <li class="papel-quadro fortuna__nota">
          <FishIcon nome="trophy" tamanho="grande" />
          <h3>{{ $t('roulette.roulette.collection.title') }}</h3>
          <p>{{ $t('roulette.roulette.collection.description') }}</p>
        </li>
      </ul>
    </div>
  </FishScene>
</template>

<script>
import Roulette from '@/shared/components/Roulette.vue';
import { FishScene, FishIcon } from '@/shared/ui';
import { mapState } from 'vuex';

export default {
  name: 'RoulettePage',
  components: {
    Roulette,
    FishScene,
    FishIcon
  },
  computed: {
    ...mapState({
      playerId: state => state.player.id
    })
  },
  i18n: {
    messages: {
      en: { roulette: true },
      pt: { roulette: true },
      es: { roulette: true },
      zh: { roulette: true }
    }
  }
}
</script>

<style scoped>
.fortuna {
  min-height: 100vh;
}

.fortuna__interior {
  max-width: 1100px;
  margin: 0 auto;
  padding: var(--e-4) var(--e-3) calc(var(--altura-barra, 104px) + var(--e-5));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-4);
}

.fortuna__topo {
  text-align: center;
}

.fortuna__titulo {
  margin: 0 0 var(--e-2);
  font-family: var(--fonte-display);
  font-size: var(--f-5);
}

.fortuna__conversa {
  margin: 0 auto;
  max-width: 560px;
  color: var(--texto-fraco);
  font-size: var(--f-2);
  line-height: var(--lh-normal);
}

.fortuna__roda {
  width: 100%;
  display: flex;
  justify-content: center;
}

.fortuna__notas {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--e-3);
  width: 100%;
}

/* As notas pendem cada uma para um lado — pregadas por mãos diferentes. */
.fortuna__nota {
  text-align: center;
  padding: var(--e-3);
}

.fortuna__nota:nth-child(odd) { transform: rotate(-0.6deg); }
.fortuna__nota:nth-child(even) { transform: rotate(0.5deg); }

.fortuna__nota h3 {
  margin: var(--e-2) 0 var(--e-1);
  font-family: var(--fonte-display);
  font-size: var(--f-3);
  color: var(--tinta);
}

.fortuna__nota p {
  margin: 0;
  font-size: var(--f-1);
  line-height: var(--lh-normal);
  color: var(--tinta-fraca);
}
</style>
